import type { FormatDollarsType } from "common/types/formatDollars"

export const formatDollars = (value: number): FormatDollarsType => {
  const balanceFormatted = value.toLocaleString("en-US")
  const [formattedDollars, cents] = balanceFormatted.split(".")

  // get only first two digits of cents or "00" if cents is undefined
  const formattedCents = cents?.slice(0, 2) || "00"

  const stringValue = `$${formattedDollars}.${formattedCents}`

  return { formattedDollars, formattedCents, stringValue }
}
